import { clsx } from 'clsx'
import { type FC } from 'react'

import { LinearGradient, type LinearGradientProps } from '@/components/gluestack'
import { COLOR_BRAND_BLUE_400, COLOR_BRAND_PURPLE_500 } from '@/lib'

export type BrandGradientViewProps = Omit<LinearGradientProps, 'colors'>

export const BrandGradientView: FC<BrandGradientViewProps> = ({ children, className, ...props }) => (
  <LinearGradient
    className={clsx('flex-1', className)}
    colors={[COLOR_BRAND_BLUE_400, COLOR_BRAND_PURPLE_500]}
    {...props}
  >
    {children}
  </LinearGradient>
)
